// removed by extract-text-webpack-plugin
module.exports = {"action-label":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___CqOS4","wrapped-input":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___2Ynl_","middle-equal":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___2Ymxv"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Loyalty/Components/Program/PointRule/PointRule.css
// module id = 2077
// module chunks = 0